import {
  Admin,
  Resource,
  CustomRoutes,
  localStorageStore,
  StoreContextProvider,
} from 'react-admin'
import { Route } from 'react-router-dom'
import { Dashboard } from './Dashboard'
import { Login } from './Login'

import AdminInvitation from './pages/AdminInvitation'

import { UserProfileList, UserProfileShow, UserProfileEdit } from './resources/userProfiles'
import { FriendList, FriendShow, FriendCreate, FriendEdit } from './resources/friends'
import { AgentConfigShow, AgentConfigList, AgentConfigEdit } from './resources/agentConfigs'
import {
  CongratulationShow,
  CongratulationList,
  CongratulationEdit,
} from './resources/congratulations'
import { JobShow, JobList } from './resources/jobs'

// https://mui.com/material-ui/material-icons/?theme=Outlined&query=report
import UserProfileIcon from '@mui/icons-material/Person4'
import FriendIcon from '@mui/icons-material/Diversity3'
import AgentConfigIcon from '@mui/icons-material/SmartToy'
import CongratulationIcon from '@mui/icons-material/Send'
import JobIcon from '@mui/icons-material/WorkHistory'

import { authProvider, buildResourcePermissions } from './authProvider'
import { dataProvider } from './dataProvider'

import MyLayout from './layout/Layout'
import { ProfileEdit } from './pages/profile'
import { customDarkTheme, customLightTheme, logInBackgroundImage } from './theme/myCustomTheme'

const resources = [
  <Resource
    name="userProfiles"
    list={UserProfileList}
    edit={UserProfileEdit}
    show={UserProfileShow}
    recordRepresentation="firstName"
    icon={UserProfileIcon}
    options={{ label: 'UserProfiles' }}
  />,
  <Resource
    name="friends"
    list={FriendList}
    edit={FriendEdit}
    create={FriendCreate}
    show={FriendShow}
    recordRepresentation="avatarUrl"
    icon={FriendIcon}
    options={{ label: 'Friends' }}
  />,
  <Resource
    name="agentConfigs"
    list={AgentConfigList}
    edit={AgentConfigEdit}
    show={AgentConfigShow}
    recordRepresentation="userId"
    icon={AgentConfigIcon}
    options={{ label: 'AgentConfigs' }}
  />,
  <Resource
    name="congratulations"
    list={CongratulationList}
    edit={CongratulationEdit}
    show={CongratulationShow}
    recordRepresentation="userId"
    icon={CongratulationIcon}
    options={{ label: 'Congratulations' }}
  />,
  <Resource
    name="jobs"
    list={JobList}
    show={JobShow}
    recordRepresentation="type"
    icon={JobIcon}
    options={{ label: 'Jobs' }}
  />,
]

const filterResources = () => {
  const allowedResources = buildResourcePermissions()
  return resources.filter((r) => allowedResources.includes(r.props.name))
}

const store = localStorageStore(undefined, 'timely-cheers-web')

const App = () => (
  <Admin
    loginPage={
      <Login
        style={{
          backgroundImage: logInBackgroundImage,
        }}
      />
    }
    dataProvider={dataProvider}
    authProvider={authProvider}
    store={store}
    dashboard={Dashboard}
    layout={MyLayout}
    theme={customLightTheme}
    darkTheme={customDarkTheme}
    defaultTheme="light"
  >
    <CustomRoutes>
      <Route key="my-profile" path="/my-profile" element={<ProfileEdit />} />
    </CustomRoutes>
    {filterResources}

    <CustomRoutes noLayout disableAuthentication>
      <Route key="invitation" path="/invitation" element={<AdminInvitation />} />
    </CustomRoutes>
  </Admin>
)

const AppWrapper = () => (
  <StoreContextProvider value={store}>
    <App />
  </StoreContextProvider>
)

export default AppWrapper
